export default "__VITE_ASSET__LhGGbAJz__"